import { useState } from "react";
import { Form } from "react-bootstrap";

interface TimeInputProps {
  hasError: boolean;
  name: string;
  value: string;
  onChange: (value: string) => void;
  onBlur?: (e: any) => void;
  className?: string;
}

const TimeInput = ({
  name,
  value,
  onChange,
  hasError,
  onBlur,
  className,
}: TimeInputProps) => {
  const handleTimeChange = (e: any) => {
    const input = e.target;
    let selectionStart = input.selectionStart;
    const overwriteValue = e.target.value;
    const numbers = overwriteValue.replace(/\D/g, "");
    const limitedNumbers = numbers.slice(0, 6);
    const parts = limitedNumbers.match(/.{1,2}/g) || [];
    const formattedTime = parts.join(":").slice(0, 8);
    if (selectionStart === 3 || selectionStart === 6) {
      selectionStart += 1;
    }
    onChange(formattedTime);
    setTimeout(
      () => input.setSelectionRange(selectionStart, selectionStart),
      0
    );
  };

  return (
    <Form.Group>
      <Form.Control
        className={hasError ? "border-danger" : ""}
        placeholder="hh:mm:ss"
        name={name}
        value={value}
        onChange={(e: any) => handleTimeChange(e)}
        onBlur={(e: any) => {
          onBlur && onBlur(e);
        }}
      />
    </Form.Group>
  );
};

export default TimeInput;
